/**
 * @file Purchase PPD Download Cart Item Container.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import get from 'lodash.get';

import { deselectDownload as deselectDownloadAction } from '../../actions/ppd-purchase';
import {
  openModal as openModalAction,
  closeModal as closeModalAction,
} from '../../actions/modal-actions';
import { PPD_CART_ITEM_TYPES } from '../../constants/ppd-purchase';
import Button from '../../components/global/Button';
import TrashIcon from '../../components/icons/TrashIcon';
import { formatPriceForDisplay } from '../../util/format-money';
import { PURCHASE_PPD_PURCHASE_PACKAGE } from '../../constants/modals';
import Photo from '../../components/global/Photo';
import { getPpdDownloadPrice } from '../../util/ppd-purchase';

class PurchasePpdDownloadCartItem extends Component {
  static propTypes = {
    cartItem: PropTypes.shape({
      type: PropTypes.oneOf([PPD_CART_ITEM_TYPES.DOWNLOAD]),
      photo: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    album: PropTypes.shape({
      id: PropTypes.string,
      photo_pricing: PropTypes.shape({
        digital_downloads_price: PropTypes.shape({
          value: PropTypes.number,
          currency: PropTypes.string,
        }),
      }),
    }),
    deselectDownload: PropTypes.func,
    openModal: PropTypes.func,
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  render() {
    const { cartItem, deselectDownload, album, openModal, history } =
      this.props;

    const { thumbnail_urls: thumbs } = cartItem.photo;
    const price = formatPriceForDisplay(
      getPpdDownloadPrice(cartItem.photo, album),
    );

    const hasPrintPackages = get(album, 'album_print_packages.total', 0) > 0;

    return (
      <div className="ppd-cart-item py-2 px-1">
        <div className="d-flex">
          <div className="cart-item-image">
            <Photo
              key={cartItem.photo.id}
              className="h-100"
              imgClassName="image-cover-img"
              thumbs={thumbs}
              blockCapture
              lowestQuality
            />
          </div>
          <div className="cart-item-desc">
            <div className="d-flex justify-content-between">
              <p className="text-sm text-dark mb-1">Hi-Res Digital Photo</p>
              <Button
                btnStyle="reset"
                onClick={() => deselectDownload(cartItem.photo)}
              >
                <TrashIcon size={23} color="#f1524b" />
              </Button>
            </div>
            <div className="d-flex justify-content-between">
              <p className="text-sm text-bold text-dark mb-0 mr-2">${price}</p>
              {hasPrintPackages && (
                <Button
                  className="text-xs text-bold text-primary mb-0 buy-as-package"
                  btnStyle="link"
                  onClick={() => {
                    openModal(PURCHASE_PPD_PURCHASE_PACKAGE, {
                      photo: cartItem.photo,
                      removeDownloadItem: true,
                    });
                    history.push(`/purchase/album/${album.id}`);
                  }}
                >
                  Buy as Print Package
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  openModal: (...args) => dispatch(openModalAction(...args)),
  closeModal: (...args) => dispatch(closeModalAction(...args)),
  deselectDownload: photo => dispatch(deselectDownloadAction(photo)),
});

export { PurchasePpdDownloadCartItem as PurchasePpdDownloadCartItemComp };

export default compose(
  withRouter,
  connect(null, mapDispatchToProps),
)(PurchasePpdDownloadCartItem);
